import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gantateam',
  templateUrl: './gantateam.component.html',
  styleUrls: ['./gantateam.component.css']
})
export class GantateamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
